import { render, staticRenderFns } from "./ViewOrderItems.vue?vue&type=template&id=17e44948&"
import script from "./ViewOrderItems.vue?vue&type=script&lang=js&"
export * from "./ViewOrderItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports